import { checkPermission } from "../../../../../functions/Functions";

const parseParties = (parties) => {
  const partiesToRetun = {};
  parties.forEach((party) => {
    if (party.show_header !== "1") return;
    const associates = party.associate_with.replace(/[\[\]]/g, "").split(",");
    associates.forEach((a) => {
      if (partiesToRetun[a]) partiesToRetun[a] = [...partiesToRetun[a], party];
      else partiesToRetun[a] = [party];
    });
  });
  return partiesToRetun;
};

const parseFoodItems = (foodItems) => {
  const parsedFoodItems = {};
  foodItems.forEach((foodItem) => {
    foodItem?.linked_branch_groups && foodItem.linked_branch_groups.map((branch) => {
      const menus = foodItem.menu_ids.replace(/[\[\]]/g, "").split(",");
      if(!branch) return;
      if (!parsedFoodItems[branch]) {
        parsedFoodItems[branch] = {};
      }
      // console.log("abcd6",foodItem,parsedFoodItems)
      menus.forEach((menu) => {
        if (!menu) return;
        if (!parsedFoodItems[branch][menu]) {
          parsedFoodItems[branch][menu] = {};
        }
        foodItem.food_groups.forEach((foodGroupId) => {
          if (!parsedFoodItems[branch][menu][foodGroupId]) {
            parsedFoodItems[branch][menu][foodGroupId] = [];
          }
          parsedFoodItems[branch][menu][foodGroupId].push(foodItem);
        });
      });
    })
  });
  // foodItems.forEach((foodItem) => {
  //   const menus = foodItem.menu_ids.replace(/[\[\]]/g, "").split(",");
  //   menus.forEach((menu) => {
  //     if (!menu) return;
  //     if (!parsedFoodItems[menu]) {
  //       parsedFoodItems[menu] = {};
  //     }
  //     foodItem?.menu_linked_branches[menu] && foodItem?.menu_linked_branches[menu]?.length &&
  //      foodItem.menu_linked_branches[menu].map((branch) => {
  //       if(!branch) return;
  //       if (!parsedFoodItems[menu][branch]) {
  //         parsedFoodItems[menu][branch] = {};
  //       }
  //       foodItem.food_groups.forEach((foodGroupId) => {
  //         if (!parsedFoodItems[menu][branch][foodGroupId]) {
  //           parsedFoodItems[menu][branch][foodGroupId] = [];
  //         }
  //         parsedFoodItems[menu][branch][foodGroupId].push(foodItem);
  //       });
  //     })
  //     // if (parsedFoodItems[menu]) {
  //     // } else {
  //     //   parsedFoodItems[menu] = {};
  //     //   foodItem.food_groups.forEach((foodGroupId) => {
  //     //     if (parsedFoodItems[menu][foodGroupId])
  //     //       parsedFoodItems[menu][foodGroupId] = [
  //     //         ...parsedFoodItems[menu][foodGroupId],
  //     //         foodItem,
  //     //       ];
  //     //     else parsedFoodItems[menu][foodGroupId] = [foodItem];
  //     //   });
  //     // }
  //   });
  // });
  return parsedFoodItems;
};

export const parseFoodItemWithGroup = (foodItems,foodGrp) => {
  const parsedFoodItems = {};
  foodItems.forEach((foodItem) => {
    foodItem.food_groups.forEach((foodGroupId) => {
      if (!parsedFoodItems[foodGroupId]) {
        const foodGroup = foodGrp[foodGroupId];
        if(foodGroup){
          parsedFoodItems[foodGroupId] = {id:foodGroup.id, name:foodGroup.name, items:[]};
        }
      }
      if(parsedFoodItems[foodGroupId]){
        parsedFoodItems[foodGroupId].items.push({ id: foodItem.id, name: foodItem.name });
      }
    });
  });
  return parsedFoodItems;
};

const qtyCounter = (action, qty) => {
  if (action === "increament") return qty + 1;
  if (action === "decreament") return qty === 0 ? 0 : qty - 1;
};

const getParsedProperties = (itemData, propertyGroups, menuWisePrice, menuId) => {
  
  const parsed = {};
  itemData.item.properties.forEach((property) => {
    if (!property.length) return
    const propertyGroupId = property[0].property_group_id.replace(
      /[\[\]]/g,
      ""
    );
    if(menuWisePrice){
    parsed[propertyGroupId] = {
      properties : property && property.map((prp)=>({
        ...prp,
        extra_price: prp.extra_price[menuId]
      }))
    }
    //parsed[propertyGroupId] = { properties: property };
    }else{
      parsed[propertyGroupId] = { properties: property };
    }
    parsed[propertyGroupId].details = propertyGroups[propertyGroupId]
  });
  return parsed;
};

const createHash = (item) => {
  let hash = item.item.id;
  if (parseInt(item.item.has_variation) === 1)
    hash += String(item.variation?.food_with_variation_id ?? "") + item.variation?.variation_name ?? "";
  if (item.item.has_property === "1") {
    if (
      item.properties &&
      Object.keys(item.properties).length
    ) {
      for (const propertyGroupId in item.properties) {
        const allproperties = Object.entries(item.properties[propertyGroupId]).map(
          ([key, value]) => String(key) + (value?.quantity || "")).join("");
        // const allproperties = Object.keys(
        //   item.properties[propertyGroupId]
        // ).join("");
        hash += propertyGroupId + allproperties;
      }
    }
  }
  if(item.offer_type === "bogo" && item.item_discount > 0){
    return hash+"x";
  }else{

    return hash;
  }
};

const getInitialItemDiscount = (price, scheme,qty = 1) => {
  const discount = parseFloat(scheme.how_much_discount);
  return (
    scheme.discount_type == 'percentage'
    ? ((discount / 100) * price)
    : discount * parseInt(qty)
  )
}

const getItemDiscount = (price, item, qty) => {
  const discount = item.discount ? parseFloat(item.discount) : 0;
  return (
    item.discount_type && item.discount_type == 'percentage'
    ? ((discount / 100) * price)
    : discount * parseInt(qty)
  )
}

const calculatePriceForCartVariation = (cartItem, qty=0) => {
  if(cartItem?.after_tax_price && Number(cartItem.after_tax_price) === 0){
    return 0
  }
  let price = (
    (cartItem && cartItem.item.has_variation === "1")
    ? (parseFloat(cartItem.variation.food_with_variation_price) * qty)
    : (parseFloat(cartItem.item.price) * qty)
  );
  return parseFloat(price.toFixed(2))
}

const calculatePriceForCartItem = (cartItem, qty=0) => {
 
  let price = (
    (cartItem.variation && Object.keys(cartItem.variation)?.length)
    ? parseFloat(cartItem.variation.food_with_variation_price)
    : parseFloat(cartItem.item.price)
  );

  if (cartItem.item.has_property === "1") {
    for (const propertyGroupId in cartItem.properties) {
      const allpropertiesPrice = Object.keys(
        cartItem.properties[propertyGroupId]
      ).reduce((total, propertyId) => {
        const property =
        cartItem.properties[propertyGroupId][propertyId];
        let qty = 1;
        if (
          property.item.hasOwnProperty("allow_multi_quantity") &&
          property.item.allow_multi_quantity === 1 &&
          property.hasOwnProperty("quantity")
        )
          qty = property.quantity;
        return (parseFloat(property.item.extra_price) * qty) + total;
      }, 0);
      price += allpropertiesPrice;
    }
  }
  return price * parseFloat((qty ? qty : (cartItem.quantity ?? 1)).toFixed(2))
}

export const calulatePriceForMenu = (menuItem, qty=0) =>{

  let price = (
    (menuItem?.variation && Object.keys(menuItem.variation)?.length)
    ? parseFloat(menuItem.variation.food_with_variation_price)
    : parseFloat(menuItem.price)
  );

  if (menuItem.has_property === "1") {
    // for (const propertyGroupId in menuItem.properties) {
    //   const allpropertiesPrice = Object.keys(
    //     menuItem.properties[propertyGroupId]
    //   ).reduce((total, propertyId) => {
    //     const property =
    //     menuItem.properties[propertyGroupId][propertyId];
    //     let qty = 1;
    //     if (
    //       property.hasOwnProperty("allow_multi_quantity") &&
    //       property.allow_multi_quantity === 1 &&
    //       property.hasOwnProperty("quantity")
    //     )
    //       qty = property.quantity;
    //     return parseFloat(property.extra_price) * qty + total;
    //   }, 0);
    //   price += allpropertiesPrice;
    // }
    const allpropertiesPrice = menuItem.properties?.length && menuItem.properties.reduce((total, property) => {
        let qty = 1;
        if (
          property.hasOwnProperty("allow_multi_quantity") &&
          property.allow_multi_quantity === 1 &&
          property.hasOwnProperty("quantity")
        )
          qty = property.quantity;
        return (parseFloat(property.extra_price) * qty) + total;
      }, 0);
      price += allpropertiesPrice;
  }
  return price * parseFloat((qty ? qty : (menuItem.quantity ?? 1)).toFixed(2))
}

const calculateSubTotal = (cartItems) => {
  return Object.values(cartItems).reduce((total, item) => {
    return (item.after_tax_price === 0 ? 0 : calculatePriceForCartItem(item)) + total;
  }, 0);
};

const getTaxedTotal = (total, tax, taxType) => {
  if (taxType === "inclusive") return total;
  return total * (1 + tax / 100);
};

//get tax price
const getTaxPrice = (price,taxPercent) => {
  return (price * (taxPercent / 100));
};

const getServiceCharges = (total,serviceCharge)=>{
  return total * (serviceCharge / 100)
}

const getDiscount = (total,discount)=>{
  return total * (discount / 100)
}

const getTax = (tax, amount) => {
  return amount * (tax / 100);
};

function customRound(num) {
  return num - Math.floor(num) < 0.6 
    ? Math.floor(num) 
    : Math.ceil(num);
}

//apply item wise loyalty
const applyItemLoyaltyPoints = (cartItems, taxType = "inclusive", branchTax = 0, result = "", directSettle = false) => {
  if(directSettle){
    let points = 0;
    const newData = Object.entries(cartItems).reduce((acc, [hash, cartItem]) => {
      const { indolj_item_id, ...item } = cartItem;
      const loyaltyHash = `${hash}loyalty`;
      const isLoyaltyItem = hash.endsWith("loyalty");
      const isTargetItem = item.item.id === result?.food_item_id;
  
      // 🧩 If this is the main item being toggled
      if (isTargetItem) {
        // Adding loyalty item
        const basePrice = Number(item.after_tax_price) / item.quantity;
        points = taxType === "inclusive"
            ? basePrice + getTax(branchTax, basePrice)
            : basePrice;

        acc[loyaltyHash] = {
          ...item,
          indolj_item_id: result.data.item_id,
          status: "loyalty",
        };
      } else if(isLoyaltyItem) {
        // Removing loyalty item (reset status)
        acc[hash.replace("loyalty", "")] = {
          ...item,
          status: "",
        };
      } else {
        // All other items remain same, but reset unwanted loyalty status
        acc[hash] = {
          ...item,
          status: item.status === "loyalty" ? "" : item.status,
        };
      }
  
      return acc;
    }, {});
    return {items: newData, points: points}

  } else {
    let points = 0;
    const newData = cartItems.map((item) => {
      const isTarget = item.food_item_id === result.food_item_id;
      if (isTarget) {
        const basePrice = Number(item.after_tax_price) / item.quantity;
        points = taxType === "inclusive"
            ? basePrice + getTax(branchTax, basePrice)
            : basePrice;
        return {
          ...item,
          indolj_item_id: result.data?.item_id,
          status: "loyalty",
        };
      } else {
        // For non-target items — return clean object without mutation
        const { indolj_item_id, ...rest } = item;
        return {
          ...rest,
          status: item.status === "loyalty" ? "" : item.status,
        };
      }
    });
    return {items: newData, points: points}
  }
}

//change loyalty point acc to tax
const updateLoyaltyPoints = (order, taxPercent= 0) => {
  let points = 0
  const loyaltyItem = order.find(item => item.status === "loyalty");
  if (loyaltyItem) {
    const price = (Number(loyaltyItem.after_tax_price) / Number(loyaltyItem.quantity));
    points = (price + getTax(taxPercent, price));
  }
  return points
}

//cal before tax price
const getBeforeTaxPrice = (price, taxType, theTax) => {
  if (taxType === "inclusive") {
    return price / (1 + (theTax / 100));
  }
  return price;
};

//set item on edit
const setItemOnEdit= (data, schemeObj, authUserInfo, roundOffPrice, taxType=null, tax, isWeb=false) => {
  // filter scheme manual
  const appliedScheme = data.scheme && data.scheme.scheme_id && schemeObj
      ? schemeObj[parseInt(data.scheme.scheme_id)]
      : null;
  const orderItem = data.orderItems;
  let newData = {}
  for (const key in orderItem) {
    const item = orderItem[key]
    const card = {
      ...item.item,
      price: item.item.price
        ? item.item.price
        : item.variation.food_with_variation_price,
    };
    const selectedCard = {
      ...item,
      item: {...card, has_variation: String(card.has_variation), ...(card?.stock_qty >= 0 && { stock_qty: Number(item.quantity) + card.stock_qty })},
    };
    
    if (!selectedCard.discount && parseFloat(selectedCard.item_discount) >= 0) {
      let discount = 0;

      if(Number(selectedCard.item_discount) > 0){
        if (appliedScheme) {
          const scheme = appliedScheme.card_required
            ? data.scheme
            : appliedScheme;
  
          discount = parseFloat(scheme?.how_much_discount || 0);
        } else if (selectedCard.scheme_id) {
          discount = parseFloat(
            schemeObj?.[selectedCard.scheme_id]?.how_much_discount || 0
          );
        } else if (selectedCard.item_discount) {
          discount = roundOffPrice((selectedCard.item_discount /
            Number(selectedCard.after_tax_price)) * 100 
          );
        }
      }

      selectedCard.discount = discount;
    }
    let cardProperties = {};
    for (const index in selectedCard.properties) {
      let Properties = selectedCard.properties[index];
      if(parseInt(authUserInfo?.details?.offline_enable) === 1){
        const {quantity, ...prpItem} = selectedCard.properties[index];
        Properties = {
          item: {
            ...prpItem,
            name:prpItem.property, 
            extra_price: prpItem.price_per_qty,
            id: prpItem.property_id,
          },
          quantity: parseInt(quantity),
        }
      }
      let Propertygroup = data?.selected_property_group_ids?.[key] && data?.selected_property_group_ids[key][index] 
        ? data.selected_property_group_ids[key][index] : JSON.parse(Properties.item.property_group_id)[0];
      const propertyId = Properties.item.id;
      cardProperties[Propertygroup] = cardProperties[Propertygroup]
        ? {
            ...cardProperties[Propertygroup],
            [propertyId]: { ...Properties },
          }
        : { [propertyId]: Properties };
    }
    // item payload on edit
    const items = {
      ...selectedCard,
      item_discount: parseFloat(selectedCard.item_discount),
      after_tax_price: parseFloat(selectedCard.after_tax_price),
      discount: parseFloat(selectedCard.discount) || 0,
      quantity: Number(selectedCard.quantity),
      variation: (parseInt(card.has_variation) === 1) ? selectedCard.variation : null,
      properties: parseInt(card.has_property) === 1 ? cardProperties : null,
    }
    // if(isWeb && taxType){
    //   items.after_tax_price = parseFloat(getBeforeTaxPrice(calculatePriceForCartItem(items, items.quantity),taxType,tax))
    // }
    let hashId = createHash(items) 
    if(authUserInfo?.permissions && checkPermission(authUserInfo.permissions, "Kitchen")){
      hashId += `-${Object.keys(newData)?.length + 1}`;
    }
    if(item.status === "complimentory" || item.status ===  "foc"){
      hashId += item.status
    }

    if(newData[hashId]){
      newData = {
        ...newData,
        [hashId]: {
          ...newData[hashId],
          item_discount: Number(newData[hashId].item_discount) + Number(items.item_discount),
          after_tax_price: Number(newData[hashId].after_tax_price) + Number(items.after_tax_price),
          discount: Number(newData[hashId].discount) + Number(items.discount),
          quantity: Number(newData[hashId].quantity) + Number(items.quantity),
        },
      };
    }else{
      newData = {
        ...newData,
        [hashId]: {
          ...items,
          new: parseInt(data?.is_hold) ? true : false,
          seq: Object.keys(newData)?.length + 1,
        },
      }
    }
  }
  return newData;
}

//auto property select 
const autoPropertySelect = (
  properties,
  id,
  pickedProperties,
  validation,
  qty = 1
) => {
  if(properties && id && properties[id] && properties[id].properties?.length === 1 && !pickedProperties[id] && validation && validation[id].required){
    let item = properties[id].properties[0];
    return {
      ...pickedProperties,
      [id]: {
        [item.id]: {
          item,
          quantity: qty || 1,
        },
      },
    };
  }else{
    return false;
  }
}

//Check validity on group select required and limit
const validationGroup = (
  newData,
  selectedPropertyGroup,
  validation,
  setTempQty
) => {
 
  // prp validation
  const items = validation;
  const selectGrop = items[selectedPropertyGroup];
  const itemGroup = newData[selectedPropertyGroup];
  if (selectGrop?.required === 1) {
    const picked = itemGroup ? Object.values(itemGroup) : [];
    const qty = picked.reduce((acc, itm) => acc + (itm?.quantity || 1), 0);
    setTempQty((curr)=>({
      ...curr,
      [selectedPropertyGroup]: qty
    }))
  }

  // if (selectGrop?.required === 1) {
  //   setRequired(true);
    
  //   if (selectGrop && selectGrop.limit > 0) {
  //     // const items = pickedProperties;
  //     // const itemGroup = items[selectedPropertyGroup];
  //     const picked = itemGroup ? Object.values(itemGroup) : [];
  //     const qty = picked.reduce((acc, itm) => acc + (itm?.quantity || 1), 0);
  //     setTempQty(qty);
  //     // const picked = [];
  //     // const itemx =
  //     // // itemGroup?.[
  //     //   itemGroup &&
  //     //   Object.values(itemGroup).map((itm) => {
  //     //       picked.push(itm.quantity ? itm.quantity : 1);
  //     //       const initial = 0;
  //     //       const qty = picked.reduce((prev, next) => prev + next, initial);
  //     //       setTempQty(qty);
  //     //     })

  //     if (tempQty > 0) {
  //       setRequired(false);
  //     }
  //   } else {
  //     setRequired(false);
  //     //setTempQty(0)
  //   }
  // } else {
  //   setRequired(false);
  // }
};

const handleKotItem = (item) => {
  const kotObj = {};
  const dataItem = item;
  let orderItems = [...dataItem.orderedItems];
  orderItems.forEach((obj) => {
    const kotKey = (!obj?.kot || obj?.kot === "No") 
      ? "No"
      : (obj?.kot_ip && typeof (obj.kot_ip) === "object")
        ? obj.kot_ip?.[dataItem?.order_type_id]
        : obj.kot_ip;
    const groupKey = obj.food_group ? obj.food_group : "None";
    const consolidatedKot = dataItem.theBranch.consolidated_kot == 1;
    const branchKot = dataItem.theBranch.consolidated_ip;
    // branch wise consolidated kot
    if(consolidatedKot){
      if(
        kotObj.hasOwnProperty(branchKot) &&
        kotObj[branchKot] &&
        Object.keys(kotObj[branchKot])?.length
      ){
        if (
          kotObj[branchKot].hasOwnProperty(groupKey) &&
          kotObj[branchKot][groupKey] &&
          kotObj[branchKot][groupKey]?.length
        ){
          kotObj[branchKot] = {
            ...kotObj[branchKot],
            [groupKey]: [...kotObj[branchKot][groupKey], { ...obj }],
          };
        }else{
          kotObj[branchKot] = {
            ...kotObj[branchKot],
            [groupKey]: [{ ...obj }],
          }
        }          
      }else{
          kotObj[branchKot] = {
            // ...kotObj[branchKot],
            [groupKey]: [{ ...obj }],
          };
      }
    }
    
    if(obj.is_special == "1" && obj?.property_item){
      obj.property_item.forEach((prop)=>{
        const kotProp = prop?.kot_ip
        ? prop.kot_ip : "No";
        const propItem = JSON.parse(JSON.stringify(prop));
        propItem.property = obj.food_item + " - " + propItem.property;

        if (
          kotObj[kotProp] &&
          kotObj.hasOwnProperty(kotProp) &&
          Object.keys(kotObj[kotProp])?.length
        ) {
          if (
            kotObj[kotProp].hasOwnProperty(groupKey) &&
            kotObj[kotProp][groupKey] &&
            kotObj[kotProp][groupKey]?.length
          ){
            kotObj[kotProp] = {
              ...kotObj[kotProp],
              [groupKey]: [...kotObj[kotProp][groupKey], { ...obj , property: {...propItem} }],
            };
          
          }else{
            kotObj[kotProp] = {
              ...kotObj[kotProp],
              [groupKey]: [{ ...obj , property: {...propItem}  }],
            };
          }
        } else {
          kotObj[kotProp] = {
            [groupKey]: [{ ...obj , property: {...propItem} }],
          };
        }
      });
    }else{
      // item wise kot
      if (
        kotObj.hasOwnProperty(kotKey) &&
        kotObj[kotKey] &&
        Object.keys(kotObj[kotKey])?.length
      ) {
        if (
          kotObj[kotKey].hasOwnProperty(groupKey) &&
          kotObj[kotKey][groupKey] &&
          kotObj[kotKey][groupKey]?.length
        ){
          kotObj[kotKey] = {
            ...kotObj[kotKey],
            [groupKey]: [...kotObj[kotKey][groupKey], { ...obj }],
          };
        
        }else{
          kotObj[kotKey] = {
            ...kotObj[kotKey],
            [groupKey]: [{ ...obj }],
          };
        }
      } else {
        kotObj[kotKey] = {
          [groupKey]: [{ ...obj }],
        };
      }
    }
  });
  
  return kotObj;
}

const onlinePayment = (item) =>{
  if(item.request_from === "POS" && item.payment_method === "Card"){
    return " Card On Delivery"
  }else if(item.payment_method === "Card" || item.payment_method === "Online"){
    return " Online Paid"
  }else if(item.payment_method === "Cash"){
    return " Cash On Delivery"
  }else{
    return " Swipe Card at your Door Step"
  }
}

export {
  parseParties,
  setItemOnEdit,
  parseFoodItems,
  qtyCounter,
  getParsedProperties,
  createHash,
  calculateSubTotal,
  calculatePriceForCartItem,
  getInitialItemDiscount,
  getItemDiscount,
  getTaxedTotal,
  getTax,
  getTaxPrice,
  updateLoyaltyPoints,
  validationGroup,
  autoPropertySelect,
  getServiceCharges,
  applyItemLoyaltyPoints,
  calculatePriceForCartVariation,
  getDiscount,
  customRound,
  handleKotItem,
  onlinePayment
};
